import React, { useMemo } from 'react';
import { FormFieldContext } from './FormFieldContext';
import { FormFieldContextType } from './types';

interface Props extends FormFieldContextType {
  children?: React.ReactNode;
}

/**
 * A component that can be used to provide form field information to other components in the
 * component tree.
 */
export const FormFieldProvider = ({ dataKey, label, labelId, errors, children }: Props) => {
  const contextValue = useMemo(
    () => ({ dataKey, label, labelId, errors }),
    [dataKey, label, labelId, errors],
  );
  return <FormFieldContext.Provider value={contextValue}>{children}</FormFieldContext.Provider>;
};
